import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLocationDot = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 9,
	height: 13,
	viewBox: "0 0 9 13",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M4.5 0.5C1.99219 0.5 0 2.51562 0 5.02344C0 6.82812 0.609375 7.34375 4.03125 12.2656C4.24219 12.5938 4.73438 12.5938 4.94531 12.2656C8.36719 7.34375 9 6.82812 9 5.02344C9 2.51562 6.98438 0.5 4.5 0.5ZM4.5 6.875C3.44531 6.875 2.625 6.05469 2.625 5C2.625 3.96875 3.44531 3.125 4.5 3.125C5.53125 3.125 6.375 3.96875 6.375 5C6.375 6.05469 5.53125 6.875 4.5 6.875Z",
		fill: "#90A4AE"
	})]
});
const ForwardRef = forwardRef(SvgLocationDot);
export { ForwardRef as ReactComponent };
